import React, { useState } from 'react';
import AsyncSelect from './AsyncSelect';

const AsyncSelectCellEditor = ((props) => {

  const {
    value,
    initialValue,
    onSearch,
    getOptionLabel,
    getOptionValue,
  } = props;

  const arrayValue = Array.isArray(value) ? true : false;
  const [selectedValue, setSelectedValue] = useState(initialValue);

  const handleChange = (option) => {
    setSelectedValue(option);
    props.onValueChange(option);
    props.stopEditing();
  };

  return (
    <div style={{ minWidth: 200, width: '100%' }}>
      <AsyncSelect
        value={selectedValue}
        multiple={arrayValue}
        onChange={handleChange}
        onSearch={onSearch}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        autoFocus
        menuPortalTarget={document.body}
        removeValue={true}
      />
    </div>
  );
});


export default AsyncSelectCellEditor;
